import { createSelector, select, Store } from '@ngrx/store'
import { map } from 'rxjs/operators'
import { State } from '../channels.state'
import { combineLatest } from 'rxjs'
import { Rental, selectAllRentals } from '@tokeet-frontend/tv3-platform'
import * as R from 'ramda'
import { channelsState } from '../channels.selectors'
import { HopperListingModel, HopperListingViewModel } from './model'

export const selectHopperState = createSelector(channelsState, (state) => state.hopper)
export const selectHopperStatus = createSelector(selectHopperState, (state) => state.status)
export const selectHopperConnected = createSelector(selectHopperState, (state) => state.status?.connected)
export const selectHopperListings = createSelector(selectHopperState, (state) => state.listings || [])
export const selectHopperRentalValidations = createSelector(selectHopperState, (state) => state.validations)
export const selectHopperValidationsLoaded = createSelector(selectHopperState, (state) => state.validationsLoaded)
export const getHopperListings = (store: Store<State>) =>
  combineLatest([store.pipe(select(selectHopperListings)), store.pipe(select(selectAllRentals))]).pipe(
    map(([listings, rentals]) => {
      return R.map((listing): HopperListingModel => {
        const rental = R.find((r: Rental) => r.id === listing._id, rentals)
        return {
          ...listing,
          rental,
          rental_name: rental?.name,
        } as HopperListingViewModel
      }, listings) as HopperListingViewModel[]
    })
  )
